import React from "react";
import classes from "./Footer.module.css";
import translate from "../../service/Language";

function Footer() {
  return (
    <div className={classes.Footer}>
      <p>
        {translate("Разработчик сайта: ", "Sayt dasturchisi: ")}{" "}
        <a href="https://t.me/jamoliddin_developer">Jamoliddin</a>
      </p>
    </div>
  );
}

export default Footer;
